export const BET_COUNT = 'common/betslip/BET_COUNT';
export const INIT = 'common/betslip/INIT';
export const DESTRUCT = 'common/betslip/DESTRUCT';
export const OPEN = 'common/betslip/OPEN';

export default function reducer(state = { initialised: false, count: 0 }, action = {}) {
  switch (action.type) {
    case BET_COUNT:
      return {
        ...state,
        count: action.count
      };
    case INIT:
      return {
          ...state,
          initialised: true
      }
    case DESTRUCT:
      return {
          ...state,
          initialised: false
      }      
    default:
      return state;
  }
}

export function setBetCount(count) {
  return {
    type: BET_COUNT,
    count
  };
}

export function openBetslip() {
    return {
      type: OPEN
    };
}

export function initBetslip() {
    return {
      type: INIT
    };
}

export function destructBetslip() {
    return {
      type: DESTRUCT
    };
}



// WEBPACK FOOTER //
// ./modules/Common/reducers/betslip.js